import { RemuneracaoMedica } from '@/types/core'
import { ItemAgendaGarantiaMinimaPeriodo } from '@/types/interfaces/FinanceiroTypes'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'AgendaGarantiaMinimaStore' })
export default class AgendaGarantiaMinimaStore extends VuexModule {
  private itemAgendaGarantiaMinimaPeriodoDefault: ItemAgendaGarantiaMinimaPeriodo = {
    id: 0,
    estabelecimentoId: '',
    localExecucaoId: '',
    nomeLocalExecucao: '',
    dataGarantia: '',
    profissionalExecutanteId: '',
    profissionalExecutanteNome: '',
    prestadorId: '',
    periodo: {
      key: '',
      display: '',
    },
    valorGarantia: 0,
    descricao: '',
    createdByNome: '',
    createdOn: '',
  }

  public modalItemAgendaGarantiaMinima: boolean = false
  public itemAgendaGarantiaMinima: ItemAgendaGarantiaMinimaPeriodo = { ...this.itemAgendaGarantiaMinimaPeriodoDefault }
  public originalItemFeriado: ItemAgendaGarantiaMinimaPeriodo = { ...this.itemAgendaGarantiaMinimaPeriodoDefault }
  public modalContext: any = null
  public prestadoresList: any[] = []
  public fontesPagadorasList: any[] = []
  public periodosList: any[] = []
  public pessoaProfissionalExecutanteList: any[] = []
  public localExecucaoList: any[] = []
  public total: number = 0
  public pagina: number = 1
  public qtdPorPagina: number = 20
  public agendaGarantiaMinimaList: ItemAgendaGarantiaMinimaPeriodo[] = []
  public itemToDeleteId: any = null
  public agendaGarantiaMinimaDrawer: boolean = false
  public dataDe: string = ''
  public dataAte: string = ''
  public selectedPrestador: string = ''
  public selectedProfissional: string = ''
  public selectedEstabelecimento: string = ''
  public selectedTurno: string = ''
  public filterOn: boolean = false
  remuneracaoMedica: RemuneracaoMedica.IPrestadorRecebimento = new RemuneracaoMedica.PrestadorRecebimento()

  @Mutation
  clearItemAgenda() {
    this.itemAgendaGarantiaMinima = { ...this.itemAgendaGarantiaMinimaPeriodoDefault }
  }

  @Mutation
  clearAgendaMinimaList() {
    this.agendaGarantiaMinimaList = []
  }

  @Mutation
  setItemGarantiaMinima(itemAgendaGarantiaMinima: ItemAgendaGarantiaMinimaPeriodo) {
    this.itemAgendaGarantiaMinima = itemAgendaGarantiaMinima
  }

  @Mutation
  setItemToDeleteId(id: any) {
    this.itemToDeleteId = id
  }

  @Mutation
  setAgendaGarantiaMinimaList(agendaGarantiaMinimaList: any[]) {
    this.agendaGarantiaMinimaList = agendaGarantiaMinimaList
  }

  @Mutation
  setOriginalItemAgendaGarantia(value: ItemAgendaGarantiaMinimaPeriodo) {
    this.originalItemFeriado = value
  }

  @Mutation
  setPrestadoresList(prestadores: any) {
    this.prestadoresList = prestadores
  }

  @Mutation
  setFontesPagadorasList(fontesPagadoras: any) {
    this.fontesPagadorasList = fontesPagadoras
  }

  @Mutation
  setLocalExecucaoList(locaisExecucao: any) {
    this.localExecucaoList = locaisExecucao
  }

  @Mutation
  setAgendaGarantiaMinimaDrawer(value: boolean) {
    this.agendaGarantiaMinimaDrawer = value
  }

  @Mutation
  setDataDe(value: string) {
    this.dataDe = value
  }

  @Mutation
  setDataAte(value: string) {
    this.dataAte = value
  }

  @Mutation
  setFilterOn(value: boolean) {
    this.filterOn = value
  }

  @Mutation
  setSelectedPrestador(value: string) {
    this.selectedPrestador = value
  }

  @Mutation
  setSelectedProfissional(value: string) {
    this.selectedProfissional = value
  }

  @Mutation
  setSelectedEstabelecimento(value: string) {
    this.selectedEstabelecimento = value
  }

  @Mutation
  setSelectedTurno(value: string) {
    this.selectedTurno = value
  }

  @Mutation
  clearFiltroAvançado() {
    this.dataDe = ''
    this.dataAte = ''
    this.selectedPrestador = ''
    this.selectedProfissional = ''
    this.selectedEstabelecimento = ''
    this.selectedTurno = ''
  }

  @Mutation
  setPeriodosList(periodos: any) {
    this.periodosList = periodos
  }

  @Mutation
  setPessoaProfissionalExecutanteList(profissionalExecutante: any) {
    this.pessoaProfissionalExecutanteList = profissionalExecutante
  }

  @Mutation
  setModal(value: any) {
    this.modalItemAgendaGarantiaMinima = value
  }

  @Mutation
  removeItemAgendaGarantia(id: string) {
    const index = this.agendaGarantiaMinimaList.findIndex((e: any) => e.id === id)
    this.agendaGarantiaMinimaList.splice(index, 1)
  }

  @Mutation
  setAgendaGarantiaMinimaPagina(pagina: number) {
    this.pagina = pagina
  }

  @Mutation
  setAgendaGarantiaMinimaTotal(total: number) {
    this.total = total
  }

  @Action
  async deleteItemAgendaGarantiaMinima() {
    try {
      const param: any = {
        id: this.itemToDeleteId,
      }
      const request = await this.remuneracaoMedica.deleteItemAgendaGarantiaMinima(param)
      if (request.success) this.context.commit('removeItemAgendaGarantia', param.id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  @Action
  async getAllItemsAgendaGarantiaMinima() {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        prestadorId: this.selectedPrestador,
        profissionalId: this.selectedProfissional,
        estabelecimentoId: this.selectedEstabelecimento,
        de: this.dataDe,
        ate: this.dataAte,
        periodo: this.selectedTurno,
      }

      const request = await this.remuneracaoMedica.getAllAgendaGarantiaMinimaPeriodo(params)

      if (request.success) {
        this.context.commit('setAgendaGarantiaMinimaList', request.data.itens as ItemAgendaGarantiaMinimaPeriodo[])
        this.context.commit('setAgendaGarantiaMinimaPagina', request.data.paginaAtual || 1)
        this.context.commit('setAgendaGarantiaMinimaTotal', request.data.totalRegistros || 0)
      }

      return request
    } catch (error) {
      this.context.commit('setItemsSenioridade', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getAgendaGarantiaMinimaPeriodoById(id: number) {
    try {
      const request = await this.remuneracaoMedica.getAgendaGarantiaMinimaPeriodoById(id)
      if (request.success) {
        this.context.commit('setItemGarantiaMinima', request.data)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async createItemAgendaGarantiaMinimaPeriodo() {
    try {
      const item = { ...this.itemAgendaGarantiaMinima }
      delete item.id

      const params = {
        estabelecimentoId: item.estabelecimentoId,
        localExecucaoId: item.localExecucaoId ? item.localExecucaoId : null,
        prestadorID: item.prestadorId,
        profissionalExecutanteId: item.profissionalExecutanteId,
        dataGarantia: item.dataGarantia,
        periodo: item.periodo.key,
        valorGarantia: item.valorGarantia,
        descricao: item.descricao,
      }

      const request = await this.remuneracaoMedica.updateItemAgendaGarantiaMinimaPeriodo(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async updateItemAgendaGarantiaMinimaPeriodo() {
    try {
      const item = { ...this.itemAgendaGarantiaMinima }

      const params = {
        id: item.id,
        estabelecimentoId: item.estabelecimentoId,
        localExecucaoId: item.localExecucaoId ? item.localExecucaoId : null,
        prestadorID: item.prestadorId,
        profissionalExecutanteId: item.profissionalExecutanteId,
        dataGarantia: item.dataGarantia,
        periodo: item.periodo.key,
        valorGarantia: item.valorGarantia,
        descricao: item.descricao,
      }

      const request = await this.remuneracaoMedica.updateItemAgendaGarantiaMinimaPeriodo(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getAllPrestadoresByHospital(params?: {limite?: number, filtro?: string}) {
    try {
      const request = await this.remuneracaoMedica.getPessoaPrestadorAll(params)
      if (request.success) {
        this.context.commit('setPrestadoresList', request.data.prestadores)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getPessoaProfissionalExecutanteAll(nomeProfissional: any) {
    try {
      const params = {
        nome: nomeProfissional
      }

      const request = await this.remuneracaoMedica.getProfissionais(params)
      if (request.success) {
        this.context.commit('setPessoaProfissionalExecutanteList', request.data.pessoas)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getFontesPagadoras() {
    try {
      const request = await this.remuneracaoMedica.getFontesPagadoras()
      if (request.success) {
        this.context.commit('setFontesPagadorasList', request.data)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getLocaisExecucao(params: any = {}) {
    try {
      const request = await this.remuneracaoMedica.getLocaisExecucaoList(params)
      if (request.success) {
        this.context.commit('setLocalExecucaoList', request.data.itens)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getPeriodos() {
    try {
      const request = await this.remuneracaoMedica.getPeriodos()
      if (request.success) {
        if (request.success) {
          this.context.commit('setPeriodosList', request.data)
        }
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
